import FormatListBulletedOutlinedIcon from "@mui/icons-material/FormatListBulletedOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import Typography from "@mui/material/Typography";
import { shallowEqual, useSelector } from "react-redux";
import { RootState } from "../../redux";
import { UserInfo } from "../../ui/models/userInfo";
import "./index.scss";

export default function DashboardPage() {
  const authInfo = useSelector<RootState, UserInfo>(
    ({ auth }: any) => auth.info,
    shallowEqual
  );

  return (
    <div className="index-container">
      <div className="novedades">
        <div className="novedad-container">
          <div className="title">
            <HandshakeOutlinedIcon />
            <Typography
              variant="h6"
              style={{ color: "#2563eb", fontWeight: 700 }}
            >
              ¡Novedad! Visualización de Convenios
            </Typography>
          </div>

          <Typography
            variant="body1"
            style={{ color: "#334155", marginBottom: 0 }}
          >
            Ahora podés visualizar los Convenios vigentes de las Obras Sociales.
            <br />
            En el menú encontrarás un nuevo ítem llamado "Convenios".
          </Typography>
        </div>
        {authInfo.role === "ADMIN" && (
          <div className="novedad-container">
            <div className="title">
              <FormatListBulletedOutlinedIcon />
              <Typography
                variant="h6"
                style={{ color: "#059669", fontWeight: 700 }}
              >
                Listado de Precarga
              </Typography>
            </div>
            <Typography
              variant="body1"
              style={{ color: "#334155", marginBottom: 0 }}
            >
              Ahora, desde el menú "SEMPRE" podrás acceder al listado de
              Precarga.
              <br />
              Para visualizar resultados es necesario aplicar algún filtro para
              la búsqueda.
            </Typography>
          </div>
        )}
      </div>
    </div>
  );
}
